import React from 'react';

import { bemBlock } from '@neptune/shared/venus-ui';

import { Merge } from 'common/utility-types';

type ComponentToggleOwnProps = {
  className?: string;
  expanded?: boolean;
  pressed?: boolean;
  onToggle?: React.ReactEventHandler;
  onCollapse?: React.ReactEventHandler;
  onExpand?: React.ReactEventHandler;
  component: string | React.ComponentType<any>;
  submenu?: boolean;
};

type ComponentToggleProps<T extends object> = Merge<T, ComponentToggleOwnProps>;

const block = bemBlock('component-toggle');

export function ComponentToggle<T extends object = any>({
  className,
  component: Component,
  onToggle,
  onCollapse,
  onExpand,
  pressed,
  ...restProps
}: ComponentToggleProps<T>): React.ReactElement {
  const cssClass = block({
    extra: [className, { 'dropdown-expanded': pressed }],
  });

  return (
    <Component
      className={cssClass}
      data-role="dropdown-toggle"
      onClick={onToggle}
      pressed={pressed}
      {...restProps}
    />
  );
}
